import type React from 'react';
import MediaRouterComponent from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/AkomiMediaCard/MediaRouterComponent';
import usePlaylistItemStyles from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/playlistItemStyles';

interface PlaylistNode {
  id: string;
  name: string;
  items?: {
    edges: Array<{
      node: {
        contentObject?: {
          id: string;
        };
      };
    }>;
  };
}

interface PlaylistItemProps {
  playlist: PlaylistNode;
  onClick: (id: string, name: string) => void;
}

const PlaylistItem: React.FC<PlaylistItemProps> = ({ playlist, onClick }) => {
  const classes = usePlaylistItemStyles();

  const handleSetPlayer = (): void => {
    // No-op for playlist items
  };

  return (
    <button type="button" className={classes.compactRow} onClick={() => onClick(playlist.id, playlist.name)}>
      <div className={classes.compactThumbnail}>
        <MediaRouterComponent
          itemId={playlist?.items?.edges[0]?.node?.contentObject?.id ?? ''}
          shared={false}
          setPlayer={handleSetPlayer}
          videoJsProps={{ options: { controls: false } }}
        />
      </div>
      <span className={classes.itemTitle}>{playlist.name}</span>
      <span className={classes.playlistItemCount}>{playlist.items?.edges?.length ?? 0}</span>
    </button>
  );
};

export default PlaylistItem;
